"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

var _I18n = _interopRequireDefault(require("I18n"));

var _Humanize = _interopRequireDefault(require("Humanize"));

var _PropertyValidations = require("customer-data-properties/validation/PropertyValidations");

var SOCIAL_SOURCE_ID = 'iwsmp';

var humanizeSource = function humanizeSource(sourceText) {
  return _Humanize.default.titlecase(sourceText.toLowerCase().replace(/_/g, ' '));
};

var getTranslationKeyFromSourceId = function getTranslationKeyFromSourceId(sourceId) {
  switch (sourceId) {
    case SOCIAL_SOURCE_ID:
      return _I18n.default.text('propertySource.sourceTypes.social');

    case 'FORWARD_TO_CRM':
      return _I18n.default.text('propertySource.sourceTypes.forwardToCrm');

    case 'EMAIL_INTEGRATION':
      return _I18n.default.text('propertySource.sourceTypes.emailIntegration');

    case 'GMAIL_INTEGRATION':
      return humanizeSource(sourceId);

    default:
      return String(sourceId).toLowerCase();
  }
};

function _default(_ref) {
  var source = _ref.source,
      sourceId = _ref.sourceId,
      sourceType = _ref.sourceType,
      sourceVids = _ref['source-vids'];

  if (sourceVids && sourceVids.size && sourceId !== SOCIAL_SOURCE_ID) {
    return _I18n.default.text('propertySource.sourceTypes.merge');
  }

  var type = sourceType || source;

  switch (type) {
    case 'API':
      return _I18n.default.text('propertySource.sourceTypes.api');

    case 'BIDEN':
      return _I18n.default.text('propertySource.sourceTypes.biden');

    case 'CALCULATED':
      if (sourceId && sourceId === 'deal-abandonment-worker') {
        return _I18n.default.text('propertySource.sourceTypes.ecommerceIntegration');
      }

      return _I18n.default.text('propertySource.sourceTypes.calculated');

    case 'COMPANIES':
      if (sourceId && sourceId.includes('ContactOwnerToCompanyPropagator')) {
        return _I18n.default.text('propertySource.sourceTypes.crmSetting');
      }

      return _I18n.default.text('propertySource.sourceTypes.companies');
    // CONTACTS_WEB, CONTACTS, SALES, and CRM_UI record the email of the user who made the
    // change as the source-id

    case 'CONTACTS_WEB':
    case 'CONTACTS':
      if (sourceId) {
        return String(sourceId).toLowerCase();
      } else {
        return _I18n.default.text('propertySource.sourceTypes.contacts');
      }

    case 'SALES':
      if (sourceId) {
        return getTranslationKeyFromSourceId(sourceId);
      } else {
        return _I18n.default.text('propertySource.sourceTypes.sales');
      }

    case 'CRM_UI':
      if (sourceId === 'ContactsOwnerUpdateToTeamUpdater') {
        return _I18n.default.text('propertySource.sourceTypes.teamSync');
      }

      return sourceId ? String(sourceId).toLowerCase() : humanizeSource(sourceType || source || '');

    case 'BATCH_UPDATE':
      if (sourceId) {
        if ((0, _PropertyValidations.isValidEmail)(sourceId)) {
          return _I18n.default.text('propertySource.sourceTypes.bulkEditWithSource', {
            sourceId: String(sourceId).toLowerCase()
          });
        }

        return _I18n.default.text('propertySource.sourceTypes.apiBulkEditWithSource', {
          sourceId: String(sourceId).toLowerCase()
        });
      }

      return _I18n.default.text('propertySource.sourceTypes.apiBulkEdit');

    case 'DEALS':
      return _I18n.default.text('propertySource.sourceTypes.deals');

    case 'EMAIL':
      if (sourceId && sourceId === 'SOURCE_SDFC_SYNC') {
        return _I18n.default.text('propertySource.sourceTypes.salesforce');
      }

      return _I18n.default.text('propertySource.sourceTypes.email');

    case 'ENGAGEMENTS':
      return _I18n.default.text('propertySource.sourceTypes.engagements');

    case 'EXTENSION':
      return _I18n.default.text('propertySource.sourceTypes.gmailExtension');

    case 'FORM':
      return _I18n.default.text('propertySource.sourceTypes.forms');

    case 'FORWARD_TO_CRM':
      return _I18n.default.text('propertySource.sourceTypes.forwardToCrm');

    case 'HEISENBERG':
      return _I18n.default.text('propertySource.sourceTypes.hubspotLocationService');

    case 'IMPORT':
      return _I18n.default.text('propertySource.sourceTypes.import');

    case 'MIGRATION':
      return _I18n.default.text('propertySource.sourceTypes.migration');

    case 'SALESFORCE':
      return _I18n.default.text('propertySource.sourceTypes.salesforce');

    case 'SOCIAL':
      return _I18n.default.text('propertySource.sourceTypes.social');

    case 'WAL_INCREMENTAL':
    case 'TASK':
      if (sourceId && sourceId === SOCIAL_SOURCE_ID) {
        return _I18n.default.text('propertySource.sourceTypes.social');
      }

      return _I18n.default.text('propertySource.sourceTypes.backgroundTask');

    case 'WORKFLOWS':
      return _I18n.default.text('propertySource.sourceTypes.workflow');

    case 'BCC_TO_CRM':
      return _I18n.default.text('propertySource.sourceTypes.bccToCRM');

    case 'EMAIL_INTEGRATION':
      return _I18n.default.text('propertySource.sourceTypes.emailIntegration');

    case 'SIDEKICK':
      return _I18n.default.text('propertySource.sourceTypes.sidekick');

    case 'MOBILE_IOS':
      return sourceId ? String(sourceId).toLowerCase() : humanizeSource(sourceType || source || '');

    case 'MOBILE_ANDROID':
      return sourceId ? String(sourceId).toLowerCase() : humanizeSource(sourceType || source || '');

    default:
      return humanizeSource(sourceType || source || '');
  }
}

module.exports = exports.default;